import React from "react"
import { createRoot } from "react-dom/client"
import { I18nextProvider } from "react-i18next"
import { Provider } from "react-redux"
import { RouterProvider } from "react-router"
import { ToastContainer } from "react-toastify"

import { i18n } from "./app/i18n"
import { store } from "./app/store"
import { router } from "./app/router"

import "./main.css"

const container = document.getElementById("root")

if (!container) {
  throw new Error(
    "Root element with ID 'root' was not found in the document. Ensure there is a corresponding HTML element with the ID 'root' in your HTML file.",
  )
}

const root = createRoot(container)

root.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18n}>
      <Provider store={store}>
        <React.Suspense>
          <RouterProvider router={router} />
        </React.Suspense>
        <ToastContainer />
      </Provider>
    </I18nextProvider>
  </React.StrictMode>,
)
